<template>
  <div class="pricing-area pb-100">
    <div class="container mw-1356">
      <div
        class="section-title mw-860 m-auto text-center"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <h2 class="text-white">خطط الأسعار والاشتراكات المقبولة</h2>
      </div>

      <div class="row justify-content-center">
        <div
          v-for="(plan, index) in pricingPlans"
          :key="index"
          class="col-xl-4 col-md-6"
          :class="{ 'mt-4 mt-xl-0': index !== 0 }"
          data-aos="fade-up"
          data-aos-duration="1000"
          :data-aos-delay="100 * (index + 1)"
        >
          <div class="pricing-single-item style-two">
            <span class="ignite d-block">
              احصل على اشتراك loay iptv المميز واستمتع بالبث
            </span>
            <div
              class="pricing-content bg-mg"
              :style="{ backgroundImage: 'url(' + plan.bgImage + ')' }"
            >
              <img :src="plan.image" :alt="plan.name + ' pricing'" />
              <div class="amount">
                <span class="months">باقة {{ plan.name }}</span>
                <h2>{{ plan.priceOneYear }}€</h2>
                <span class="renew d-block mb-2">سنة واحدة</span>
                <span class="badge bg-warning text-dark p-2 fw-bold d-inline-block mb-3">
                  {{ plan.priceTwoYears }}€ / سنتين
                </span>
                <span class="renew d-block">تجديد يدوي (لا يوجد سحب تلقائي)</span>
              </div>

              <ul class="ps-0 list-unstyled pricing-list">
                <li
                  v-for="(feature, i) in plan.features"
                  :key="i"
                  class="d-flex justify-content-between align-items-center"
                >
                  <span>{{ feature.name }}</span>
                  <i
                    class="ti ti-circle-check"
                    :class="{ 'opacity-25': !feature.included }"
                  ></i>
                </li>
              </ul>

              <!-- رابط مباشر إلى الواتساب بدون تعقيد الرسائل المسبقة -->
              <a href="https://wa.me/447429916178" target="_blank" class="btn active">
                <span class="border-style">اشترك الآن</span>
              </a>
            </div>
          </div>
        </div>

        <div class="col-lg-12 text-center mt-4 mt-lg-5">
          <p class="text-silver">
            ضمان استرداد الأموال بنسبة <strong>100%</strong> خلال أول 24 ساعة.
            <RouterLink
              to="/services"
              class="read-more style-two text-grey-teal"
            >
              لمعرفة المزيد <i class="ti ti-arrow-right"></i>
            </RouterLink>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "PricingPlans",
  setup() {
    /* eslint-disable @typescript-eslint/no-var-requires */
    const pricingPlans = ref([
      {
        name: "Lite",
        priceOneYear: "30",
        priceTwoYears: "50",
        bgImage: require("@/assets/images/pricing-bg-1.jpg"),
        image: require("@/assets/images/pricing-1.png"),
        features: [
          { name: "البث المباشر ودليل القنوات (EPG)", included: true },
          { name: "مكتبة الأفلام والمسلسلات (VOD)", included: true },
          { name: "جودة بث القياسية و FHD", included: true },
          { name: "تحديثات دورية للمحتوى", included: true },
          { name: "جهاز واحد في نفس الوقت", included: true },
          { name: "دعم فني عادي", included: true },
          { name: "إعداد وتخصيص قائمة المحتوى المتقدمة", included: false },
          { name: "ثبات فائق وسيرفرات مضادة للتقطيع (4K)", included: false },
        ],
      },
      {
        name: "Ultra",
        priceOneYear: "40",
        priceTwoYears: "60",
        bgImage: require("@/assets/images/pricing-bg-2.jpg"),
        image: require("@/assets/images/pricing-2.png"),
        features: [
          { name: "البث المباشر ودليل القنوات (EPG)", included: true },
          { name: "مكتبة الأفلام والمسلسلات (VOD)", included: true },
          { name: "دعم جودة فائقة 4K و UHD", included: true },
          { name: "ثبات فائق وسيرفرات مضادة للتقطيع (4K)", included: true },
          { name: "تحديثات فورية ويومية للمحتوى", included: true },
          { name: "جهازين في نفس الوقت", included: true },
          { name: "إعداد وتخصيص قائمة المحتوى المتقدمة", included: false },
          { name: "أولوية الدعم الفني 24/7", included: false },
        ],
      },
      {
        name: "Pro",
        priceOneYear: "45",
        priceTwoYears: "70",
        bgImage: require("@/assets/images/pricing-bg-3.jpg"),
        image: require("@/assets/images/pricing-3.png"),
        features: [
          { name: "البث المباشر ودليل القنوات (EPG)", included: true },
          { name: "مكتبة الأفلام والمسلسلات (VOD)", included: true },
          { name: "دعم جودة فائقة 4K و Ultra HD", included: true },
          { name: "ثبات فائق وسيرفرات مضادة للتقطيع (4K)", included: true },
          { name: "تشغيل متزامن على عدة أجهزة", included: true },
          { name: "إعداد وتخصيص قائمة المحتوى المتقدمة", included: true },
          { name: "أولوية الدعم الفني والتركيب الفوري 24/7", included: true },
          { name: "وصول كامل للأحداث والبطولات الحصرية", included: true },
        ],
      },
    ]);
    /* eslint-enable @typescript-eslint/no-var-requires */

    return { pricingPlans };
  },
});
</script>